var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 8.33366H3.33317C2.41234 8.33366 1.6665 7.58783 1.6665 6.66699V3.33366C1.6665 2.41283 2.41234 1.66699 3.33317 1.66699H6.6665C7.58734 1.66699 8.33317 2.41283 8.33317 3.33366V6.66699C8.33317 7.58783 7.58734 8.33366 6.6665 8.33366Z",
    stroke: "#7F8585",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 8.33366H13.3332C12.4123 8.33366 11.6665 7.58783 11.6665 6.66699V3.33366C11.6665 2.41283 12.4123 1.66699 13.3332 1.66699H16.6665C17.5873 1.66699 18.3332 2.41283 18.3332 3.33366V6.66699C18.3332 7.58783 17.5873 8.33366 16.6665 8.33366Z",
    stroke: "#7F8585",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 18.3337H3.33317C2.41234 18.3337 1.6665 17.5878 1.6665 16.667V13.3337C1.6665 12.4128 2.41234 11.667 3.33317 11.667H6.6665C7.58734 11.667 8.33317 12.4128 8.33317 13.3337V16.667C8.33317 17.5878 7.58734 18.3337 6.6665 18.3337Z",
    stroke: "#7F8585",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 18.3337H13.3332C12.4123 18.3337 11.6665 17.5878 11.6665 16.667V13.3337C11.6665 12.4128 12.4123 11.667 13.3332 11.667H16.6665C17.5873 11.667 18.3332 12.4128 18.3332 13.3337V16.667C18.3332 17.5878 17.5873 18.3337 16.6665 18.3337Z",
    stroke: "#7F8585",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridInactive);
export default __webpack_public_path__ + "static/media/grid-inactive.78597d9d0c26b2181d0944d3d16f9d14.svg";
export { ForwardRef as ReactComponent };